export const FETCH_USERS = "[ADMIN] FETCH_USERS";
export const FETCH_USERS_START = "[ADMIN] FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "[ADMIN] FETCH_USERS_SUCCESS";

export const FETCH_USERS_ERROR = "[ADMIN] FETCH_USERS_ERROR";

export const SET_SELECTED_USER = "[ADMIN] SET_SELECTED_USER"
export const ADD_USER = "[ADMIN] ADD_USER";
export const ADD_USER_SUCCESS = "[ADMIN] ADD_USER_SUCCESS";
export const ADD_USER_ERROR = "[ADMIN] ADD_USER_ERROR";

export const UPDATE_USER_ACCOUNT = "[ADMIN] UPDATE_USER_ACCOUNT";
export const UPDATE_USER_ACCOUNT_START = "[ADMIN] UPDATE_USER_ACCOUNT_START";
export const UPDATE_USER_ACCOUNT_SUCCESS = "[ADMIN] UPDATE_USER_ACCOUNT_SUCCESS";
export const UPDATE_USER_ACCOUNT_ERROR = "[ADMIN] UPDATE_USER_ACCOUNT_ERROR";

export const FETCH_USER_SKILLS = "[ADMIN] FETCH_USER_SKILLS";
export const FETCH_USER_SKILLS_START = "[ADMIN] FETCH_USER_SKILLS_START";
export const FETCH_USER_SKILLS_SUCCESS = "[ADMIN] FETCH_USER_SKILLS_SUCCESS";
export const FETCH_USER_SKILLS_ERROR = "[ADMIN] FETCH_USER_SKILLS_ERROR";

export const ADD_USER_SKILL = "[ADMIN] ADD_USER_SKILL";
export const ADD_USER_SKILL_START = "[ADMIN] ADD_USER_SKILL_START";
export const ADD_USER_SKILL_SUCCESS = "[ADMIN] ADD_USER_SKILL_SUCCESS";
export const ADD_USER_SKILL_ERROR = "[ADMIN] ADD_USER_SKILL_ERROR";

export const DELETE_USER_SKILL = "[ADMIN] DELETE_USER_SKILL";
export const DELETE_USER_SKILL_START = "[ADMIN] DELETE_USER_SKILL_START";
export const DELETE_USER_SKILL_SUCCESS = "[ADMIN] DELETE_USER_SKILL_SUCCESS";
export const DELETE_USER_SKILL_ERROR = "[ADMIN] DELETE_USER_SKILL_ERROR";

// export const UPDATE_USER_SITES = "[ADMIN] UPDATE_USER_SITES";
// export const UPDATE_USER_SITES_SUCCESS = "[ADMIN] UPDATE_USER_SITES_SUCCESS";
// export const UPDATE_USER_SITES_ERROR = "[ADMIN] UPDATE_USER_SITES_ERROR";

export const RESET_USER_PASSWORD = "[ADMIN] RESET_USER_PASSWORD";
export const RESET_USER_PASSWORD_START = "[ADMIN] RESET_USER_PASSWORD_START";
export const RESET_USER_PASSWORD_SUCCESS = "[ADMIN] RESET_USER_PASSWORD_SUCCESS";
export const RESET_USER_PASSWORD_ERROR = "[ADMIN] RESET_USER_PASSWORD_ERROR";

export const FETCH_ALL_TECHNICIANS = "[ADMIN] FETCH_ALL_TECHNICIANS";
export const FETCH_ALL_TECHNICIANS_START = "[ADMIN] FETCH_ALL_TECHNICIANS_START";
export const FETCH_ALL_TECHNICIANS_SUCCESS = "[ADMIN] FETCH_ALL_TECHNICIANS_SUCCESS";
export const FETCH_ALL_TECHNICIANS_ERROR = "[ADMIN] FETCH_ALL_TECHNICIANS_ERROR";

export const FETCH_ALL_DOCTORS = "[ADMIN] FETCH_ALL_DOCTORS";
export const FETCH_ALL_DOCTORS_START = "[ADMIN] FETCH_ALL_DOCTORS_START";
export const FETCH_ALL_DOCTORS_SUCCESS = "[ADMIN] FETCH_ALL_DOCTORS_SUCCESS";
export const FETCH_ALL_DOCTORS_ERROR = "[ADMIN] FETCH_ALL_DOCTORS_ERROR";

export const FETCH_RIS_USERS_WITH_MIPS = "[ADMIN] FETCH_RIS_USERS_WITH_MIPS";
export const FETCH_RIS_USERS_WITH_MIPS_START = "[ADMIN] FETCH_RIS_USERS_WITH_MIPS_START";
export const FETCH_RIS_USERS_WITH_MIPS_SUCCESS = "[ADMIN] FETCH_RIS_USERS_WITH_MIPS_SUCCESS";
export const FETCH_RIS_USERS_WITH_MIPS_ERROR = "[ADMIN] FETCH_RIS_USERS_WITH_MIPS_ERROR";

export const CREATE_RIS_USER = "[ADMIN] CREATE_RIS_USER";
export const CREATE_RIS_USER_START = "[ADMIN] CREATE_RIS_USER_START";
export const CREATE_RIS_USER_SUCCESS = "[ADMIN] CREATE_RIS_USER_SUCCESS";
export const CREATE_RIS_USER_ERROR = "[ADMIN] CREATE_RIS_USER_ERROR";

export const ADD_UPDATE_RIS_USER_MIPS = "[ADMIN] ADD_UPDATE_RIS_USER_MIPS";
export const ADD_UPDATE_RIS_USER_MIPS_START = "[ADMIN] ADD_UPDATE_RIS_USER_MIPS_START";
export const ADD_UPDATE_RIS_USER_MIPS_SUCCESS = "[ADMIN] ADD_UPDATE_RIS_USER_MIPS_SUCCESS";
export const ADD_UPDATE_RIS_USER_MIPS_ERROR = "[ADMIN] ADD_UPDATE_RIS_USER_MIPS_ERROR";

export const UPDATE_RIS_USER = "[ADMIN] UPDATE_RIS_USER";
export const UPDATE_RIS_USER_START = "[ADMIN] UPDATE_RIS_USER_START";
export const UPDATE_RIS_USER_SUCCESS = "[ADMIN] UPDATE_RIS_USER_SUCCESS";
export const UPDATE_RIS_USER_ERROR = "[ADMIN] UPDATE_RIS_USER_ERROR";

export const DELETE_RIS_USER = "[ADMIN] DELETE_RIS_USER";
export const DELETE_RIS_USER_SUCCESS = "[ADMIN] DELETE_RIS_USER_SUCCESS";
export const DELETE_RIS_USER_ERROR = "[ADMIN] DELETE_RIS_USER_ERROR";

export const SET_USERS_PAGINATION = "[ADMIN] SET_USERS_PAGINATION";

export const UNASSIGN_USER_MIP = "[ADMIN] UNASSIGN_USER_MIP";
export const UNASSIGN_USER_MIP_SUCCESS = "[ADMIN] UNASSIGN_USER_MIP_SUCCESSS";
export const UNASSIGN_USER_MIP_ERROR = "[ADMIN] UNASSIGN_USER_MIP_ERROR";

export const FETCH_USER_MIPS = "[ADMIN] FETCH_USER_MIPS";
export const FETCH_USER_MIPS_SUCCESS = "[ADMIN] FETCH_USER_MIPS_SUCCESS";
export const FETCH_USER_MIPS_ERROR = "[ADMIN] FETCH_USER_MIPS_ERROR";

export const ASSIGN_USER_MIP = "[ADMIN] ASSIGN_USER_MIP";
export const ASSIGN_USER_MIP_SUCCESS = "[ADMIN] ASSIGN_USER_MIP_SUCCESS";
export const ASSIGN_USER_MIP_ERROR = "[ADMIN] ASSIGN_USER_MIP_ERROR";

export const RESET_USER_MIPS = "[ADMIN] RESET_USER_MIPS";

export const UPDATE_USER_MIPS = "[ADMIN] UPDATE_USER_MIPS";
export const UPDATE_USER_MIPS_SUCCESS = "[ADMIN] UPDATE_USER_MIPS_SUCCESS";
export const UPDATE_USER_MIPS_ERROR = "[ADMIN] UPDATE_USER_MIPS_ERROR";

export const setSelectedUser = (payload) => {    
    return {
        type: SET_SELECTED_USER,
        payload
    }
}

export const fetchUsers = (payload) => {
    return {
        type: FETCH_USERS,
        payload
    };
};

export const fetchUsersSuccess = (users) => {
    return {
        type: FETCH_USERS_SUCCESS,
        users: users
    };
};

export const fetchUsersError = (error) => {
    return {
        type: FETCH_USERS_ERROR,
        error: error
    };
};

export const addNewUser = (user) => {
    return {
        type: ADD_USER,
        user
    };
};

export const updateUserAccount = (userAccount) => {
    return {
        type: UPDATE_USER_ACCOUNT,
        userAccount
    };
};

// export const updateUserSites = (user) => {
//     return {
//         type: UPDATE_USER_SITES,
//         user
//     };
// };

export const resetUserPassword = (user) => {
    return {
        type: RESET_USER_PASSWORD,
        user
    };
}

export const fetchAllTechiniciansBySite = (siteId) => {
    return {
        type: FETCH_ALL_TECHNICIANS,
        payload: { siteId }
    };
};

export const fetchAllDoctors = () => {
    return {
        type: FETCH_ALL_DOCTORS,
    };
};

export const getRisUsersWithMips = (userId) => {
    return {
        type: FETCH_RIS_USERS_WITH_MIPS,
        userId: userId
    };
};

export const createRisUser = (risUser) => {
    return {
        type: CREATE_RIS_USER,
        risUser
    };
}

export const addUpdateRisUserMips = (risUser) => {
    return {
        type: ADD_UPDATE_RIS_USER_MIPS,
        risUser
    };
}

export const updateRisUser = (risUser, callback) => {
    return {
        type: UPDATE_RIS_USER,
        risUser,
        callback
    };
}

export const deleteRisUser = (userId, risId) => {
    return {
        type: DELETE_RIS_USER,
        payload: { userId, risId }
    };
}

export const unAssignUserMip = (payload) => {
    return {
        type: UNASSIGN_USER_MIP,
        payload
    };
}

export const fetchUserSkills = (userId) => {
    return {
        type: FETCH_USER_SKILLS,
        userId
    };
}

export const addUserSkill = (userSkill) => {
    return {
        type: ADD_USER_SKILL,
        userSkill
    };
}

export const deleteUserSkill = (userSkill) => {
    return {
        type: DELETE_USER_SKILL,
        userSkill
    };
}

export const fetchUserMips = (userId) => {
    return {
        type: FETCH_USER_MIPS,
        payload: userId
    }
}


export const assignUserMip = (mip, callback) => {
    return {
        type: ASSIGN_USER_MIP,
        payload: mip,
        callback
    }
}

export const resetUserMips = () => {
    return {
        type: RESET_USER_MIPS,
    }
}

export const addUpdateUserMips = (userMips, userId) => {
    return {
        type: UPDATE_USER_MIPS,
        payload: { userMips, userId }
    }
}
